import { uniq } from 'lodash';
import { useMemo } from 'react';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { useLegacyBenefitHistoricalProposal } from '~/data/proposals/useGetLegacyHistoricalProposals';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { isRoleHRAdmin } from '~/services/Permissions';

import { useBenefitProposalColumns } from '../../common';
import {
  BenefitProposalWorkflowTable,
  ProposalsHistoryTableLayout,
} from '../components';

export const BenefitProposalHistoryTable = () => {
  const roles = useLoggedInUserRoles();
  const isHRAdmin = isRoleHRAdmin(roles);
  const loggedInId = useLoggedInEmployeeId();
  const { selectedEmployeeId: employeeId } = useSelectedEmployeeId();
  const { data } = useLegacyBenefitHistoricalProposal({
    employeeId,
  });

  const { rows, employmentIds } = useMemo(() => {
    const rows =
      loggedInId === employeeId && !isHRAdmin
        ? data.filter((item) => item.fBenefitProposalStatus !== 'FAILED')
        : data;

    return { rows, employmentIds: uniq(rows.map((r) => r.fEmplId)) };
  }, [data, loggedInId, employeeId, isHRAdmin]);

  const columns = useBenefitProposalColumns({ employmentIds });

  return (
    <ProposalsHistoryTableLayout
      rows={rows}
      columns={columns}
      employeeId={employeeId}
      proposalWorkflowTable={BenefitProposalWorkflowTable}
    />
  );
};
